import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import './style.scss';
import BaseComponent from '../../../../base/component';
import { getCurrentEventType, isFeedbackRequested, canRemoveFeedbackRequest } from '../../../../core/filters/commonFilters';
import { eventTypes } from '../../../../core/route/workflowService';
import logger from '../../../../../shared/logger';
import { RECRUITER_WORKFLOW_STATUS } from '../../../constants/recruiter-workflow';

export const CANDIDATE_ACTIONS = {
    APPROVE_PROFILE: 'APPROVE_PROFILE',
    APPROVE_SUBMISSION: 'APPROVE_SUBMISSION',
    BACK_TO_PREV_STATUS: 'BACK_TO_PREV_STATUS',
    BACK_TO_PROSPECTS: 'BACK_TO_PROSPECTS',
    CLAIM: 'CLAIM',
    CONTACT_CAND: 'CONTACT_CAND',
    CONFIRM_RESPONSE: 'CONFIRM_RESPONSE',
    CREATE_RESUME_FOR_EMPLOYER: 'CREATE_RESUME_FOR_EMPLOYER',
    HIDE: 'HIDE',
    INTERVIEW: 'INTERVIEW',
    ON_BEHALF_OF_EMPLOYER: 'ON_BEHALF_OF_EMPLOYER',
    REJECT: 'REJECT',
    REMOVE_REQUEST_FEEDBACK: 'REMOVE_REQUEST_FEEDBACK',
    REQUEST_FEEDBACK: 'REQUEST_FEEDBACK',
    SEND_RESUME_TO_EMP: 'SEND_RESUME_TO_EMP',
    SEND_RESUME_TO_CANDIDATE: 'SEND_RESUME_TO_CANDIDATE',
    SAMPLES_ADD_MENU_ITEM: 'SAMPLES_ADD_MENU_ITEM',
    WAITING_FOR_CANDIDATE_APPROVAL: 'WAITING_FOR_CANDIDATE_APPROVAL',
};

export class CallForActionButton extends BaseComponent {
    /* @ngInject */
    $onInit(...args) {
        super.$onInit(...args);
        this.$scope.searchCtrl = this.searchCtrl;
        this.$scope.CANDIDATE_ACTIONS = CANDIDATE_ACTIONS;
    }

    _getCurrentEventType() {
        const events = _.get(this.searchCtrl, 'currentCandidate.workflow.events');
        return getCurrentEventType(events);
    }

    _isFeedbackRequested() {
        const events = _.get(this.searchCtrl, 'currentCandidate.workflow.events');
        return isFeedbackRequested(events);
    }

    _canRemoveFeedbackRequest() {
        const workflow = _.get(this.searchCtrl, 'currentCandidate.workflow');
        return canRemoveFeedbackRequest(workflow);
    }

    getActiveCallForAction() {
        if (!this.searchCtrl.currentCandidate) {
            return '';
        }

        const recruiterStatus = _.get(this.searchCtrl, 'currentCandidate.workflow.recruiterStatus.current');
        const employerContactCandidates = _.get(this.searchCtrl, 'searchData.positionData.employerContactCandidates');
        const interviewsCount = _.get(this.searchCtrl, 'currentCandidate.interviews.length');

        switch (true) {
            case ((this.searchCtrl.searchData.backButtonText === 'PROSPECTS'
                    || (this.searchCtrl.searchData.backButtonText === 'FEEDBACK' && recruiterStatus === 'Prospect')) &&
                recruiterStatus !== RECRUITER_WORKFLOW_STATUS.HIDDEN
            ):
                return CANDIDATE_ACTIONS.CLAIM;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.CLAIMED &&
                !employerContactCandidates &&
                this._getCurrentEventType() === eventTypes.CONTACT_CANDIDATE &&
                this.searchCtrl.showContactCand):
                return CANDIDATE_ACTIONS.CONTACT_CAND;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.CLAIMED &&
                employerContactCandidates &&
                this.searchCtrl.showContactCand &&
                this._getCurrentEventType() !== eventTypes.CONFIRM_RESPONSE):
                return CANDIDATE_ACTIONS.SEND_RESUME_TO_EMP;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.CLAIMED && this._getCurrentEventType() === eventTypes.CONFIRM_RESPONSE):
                return CANDIDATE_ACTIONS.CONFIRM_RESPONSE;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.CLAIMED &&
                !(this._isFeedbackRequested()) &&
                !employerContactCandidates &&
                this._getCurrentEventType() === 'requestFeedback'):
                return CANDIDATE_ACTIONS.REQUEST_FEEDBACK;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED && this.searchCtrl.engagedStep === 'resumeApproved'):
                return CANDIDATE_ACTIONS.APPROVE_SUBMISSION;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED && this.searchCtrl.engagedStep === 'resumeSent'):
                return CANDIDATE_ACTIONS.WAITING_FOR_CANDIDATE_APPROVAL;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED && this.searchCtrl.engagedStep === 'resumeCreated'):
                return this.isCandidateConsentsRequired ? CANDIDATE_ACTIONS.APPROVE_SUBMISSION : CANDIDATE_ACTIONS.SEND_RESUME_TO_CANDIDATE;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED &&
                (!this.searchCtrl.engagedStep || this.searchCtrl.engagedStep === 'none') && interviewsCount > 0):
                logger.info({
                    engagedStep: this.searchCtrl.engagedStep,
                    interviewsCount,
                });
                return CANDIDATE_ACTIONS.CREATE_RESUME_FOR_EMPLOYER;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.ENGAGED &&
                (!this.searchCtrl.engagedStep || this.searchCtrl.engagedStep === 'none') && interviewsCount <= 0):
                return CANDIDATE_ACTIONS.INTERVIEW;

            case (recruiterStatus === RECRUITER_WORKFLOW_STATUS.REJECTED):
                return CANDIDATE_ACTIONS.BACK_TO_PREV_STATUS;

            default:
                return '';
        }
    }

    getExtraAction() {
        const recruiterStatus = _.get(this.searchCtrl, 'currentCandidate.workflow.recruiterStatus.current');

        const showHideButton = (recruiterStatus === 'Prospect' || !_.get(this.searchCtrl, 'currentCandidate.workflow'))
            && recruiterStatus !== 'Hidden';

        if (showHideButton) {
            return CANDIDATE_ACTIONS.HIDE;
        }

        return '';
    }

    isMenuItemAvailable(item) {
        if (!this.searchCtrl.currentCandidate) {
            return false;
        }

        const recruiterStatus = _.get(this.searchCtrl, 'currentCandidate.workflow.recruiterStatus.current');
        const employerStatus = _.get(this.searchCtrl, 'currentCandidate.workflow.employerStatus.current');
        const employerContactCandidates = _.get(this.searchCtrl, 'searchData.positionData.employerContactCandidates');
        const interviewsCount = _.get(this.searchCtrl, 'currentCandidate.interviews.length');

        switch (item) {
            case CANDIDATE_ACTIONS.SEND_RESUME_TO_EMP:
                return (
                    recruiterStatus === 'Claimed'
                    && employerContactCandidates
                    && this._getCurrentEventType() === eventTypes.CONFIRM_RESPONSE
                ) || (
                    recruiterStatus === 'Engaged'
                    && employerContactCandidates
                );

            case CANDIDATE_ACTIONS.CONTACT_CAND:
                return (
                    recruiterStatus === 'Claimed'
                    && this._getCurrentEventType() !== eventTypes.CONTACT_CANDIDATE
                ) || (
                    recruiterStatus === 'Claimed'
                    && this._getCurrentEventType() === eventTypes.CONTACT_CANDIDATE
                    && employerContactCandidates
                ) || (
                    ['Ready', 'Engaged', 'Sent'].includes(recruiterStatus)
                );
            case CANDIDATE_ACTIONS.INTERVIEW:
                return (
                    recruiterStatus === 'Claimed'
                    || (
                        recruiterStatus === 'Engaged'
                        && interviewsCount > 0
                    )
                );
            case CANDIDATE_ACTIONS.BACK_TO_PREV_STATUS:
                return this.searchCtrl.currentCandidate.workflow &&
                    !(['Prospect', 'Hidden', 'Rejected', 'Hired', 'Sent'].includes(recruiterStatus));

            case CANDIDATE_ACTIONS.CREATE_RESUME_FOR_EMPLOYER:
                return recruiterStatus === 'Engaged' && (
                    this.searchCtrl.engagedStep === 'resumeCreated'
                    || this.searchCtrl.engagedStep === 'resumeApproved'
                );

            case CANDIDATE_ACTIONS.ON_BEHALF_OF_EMPLOYER:
                return ['Sent', 'Hired'].includes(recruiterStatus) || employerStatus === 'Rejected';

            case CANDIDATE_ACTIONS.REQUEST_FEEDBACK:
                return recruiterStatus
                    && !(['Prospect', 'Rejected', 'Hired', 'Sent'].includes(recruiterStatus))
                    && !this._isFeedbackRequested()
                    && (
                        (
                            this._getCurrentEventType() === 'requestFeedback'
                            && recruiterStatus !== 'Claimed'
                        ) || (
                            this._getCurrentEventType() !== 'requestFeedback'
                            && recruiterStatus === 'Claimed'
                        ) || employerContactCandidates
                    );
            case CANDIDATE_ACTIONS.APPROVE_PROFILE:
                return recruiterStatus === 'Engaged'
                    && this.searchCtrl.engagedStep === 'resumeCreated';

            case CANDIDATE_ACTIONS.SEND_RESUME_TO_CANDIDATE:
                return recruiterStatus === 'Engaged'
                    && this.searchCtrl.engagedStep === 'resumeSent';

            case CANDIDATE_ACTIONS.REMOVE_REQUEST_FEEDBACK:
                return !(['Prospect', 'Rejected', 'Hired', 'Sent'].includes(recruiterStatus))
                    && this._canRemoveFeedbackRequest();

            case CANDIDATE_ACTIONS.REJECT:
                return this.searchCtrl.currentCandidate.workflow
                    && !(['Prospect', 'Hidden', 'Rejected', 'Hired', 'Sent'].includes(recruiterStatus));

            case CANDIDATE_ACTIONS.BACK_TO_PROSPECTS:
                return ['Hidden', 'Engaged', 'Ready'].includes(recruiterStatus)
                    || (
                        recruiterStatus === 'Rejected'
                        && employerStatus === 'None'
                    );

            case CANDIDATE_ACTIONS.SAMPLES_ADD_MENU_ITEM:
                return _.get(this.searchCtrl, 'currentCandidate.canAddSample.result');

            default:
                logger.error('Unknown candidate action menu item');
                return false;
        }
    }
}

export const CallForActionButtonConfiguration = {
    template,
    controller: CallForActionButton,
    bindings: {
        isCandidateConsentsRequired: '<',
    },
    require: {
        searchCtrl: '^searchComponent',
    },
    controllerAs: 'callForActionButtonCtrl',
};

angular
    .module('TALENYA-FE')
    .component('callForActionButton', CallForActionButtonConfiguration);
